import { FC } from 'react';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';
import Algoverse from './Algoverse';
import { PARTNER_NAME } from 'v2/common/utils/types.type';
import Default from './Default';
import Qubit from './Qubit';

const Footer: FC = () => {
  switch (ApplicationDomainUtility.partnerName) {
    case PARTNER_NAME.ALGOVERSE:
      return <Algoverse />;
    case PARTNER_NAME.STOCKWIZ:
      return <></>;
    case PARTNER_NAME.QUBIT:
      return <Qubit />;
    default:
      return <Default />;
  }
};

export default Footer;
